import { RowItem, SplashContext } from '@/lib/core/types';
import { StepRow } from './row';
import { ApiBlockItemModel, IApiElementModel } from '@/services/platform/api/model';

interface StepsRowProps {
  steps?: ApiBlockItemModel[] | undefined;
  context?: SplashContext;
}

export function StepsRow({ steps, context }: StepsRowProps) {
  if (!steps?.length) return null;

  const rows: RowItem[] | null = [];
  let currentRow: RowItem | null = null;

  steps.map((step, index) => {
    if (index === 0 && (step?.content as IApiElementModel)?.contentType !== 'row' && !currentRow) {
      currentRow = {
        row: {
          content: {
            contentType: 'row',
            properties: {
              fullWidth: true,
            },
          },
        } as ApiBlockItemModel,
        components: [],
      };
    }

    if (step?.content?.contentType === 'row') {
      if (currentRow) {
        rows.push(currentRow);
      }
      currentRow = {
        row: step,
        components: [],
      };
    } else if (currentRow) {
      currentRow.components.push(step);
    }
  });

  if (currentRow) {
    rows.push(currentRow);
  }

  return (
    <div className="relative w-full">
      {rows.map((row, rowIndex) => (
        <StepRow key={rowIndex} index={rowIndex} row={row} context={context} />
      ))}
    </div>
  );
}
